<!-- 受入先の会社一覧。サブ組ベンダー/EPSONが設定される想定 -->
<template>
  <SelectSingleInput
    v-model="model"
    :items="items"
    item-text="companyText"
    item-value="companyCd"
    :label="label"
    :disabled="disabledComputed"
    :loading="loading"
    :required="required"
  />
</template>

<script>
import SelectSingleInput from '@/components/atoms/base/select/SelectSingleInput'
import { API } from '@/plugins/api'
import { InspCat } from '@/enum'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'

export default {
  name: 'AcceptCompanyInput',

  mixins: [APIUtils, Message],

  components: { SelectSingleInput },

  props: {
    value: {
      type: String,
      default: '',
      required: true,
    },
    label: {
      type: String,
      required: false,
      default: function () {
        return this.$t('ELE0005')
      },
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
    validOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      items: [],
      loading: false,
    }
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value ? value : '')
      },
    },
    disabledComputed: {
      get() {
        return this.disabled || this.$store.getters.isSupplier
      },
    },
  },

  async mounted() {
    this.loading = true
    try {
      let params = {
        validOnly: this.validOnly,
        inspCat: InspCat.OQC_IQC,
      }
      // 無関係な会社の選択肢が出ないように、サプライヤーの場合も検索条件指定
      if (this.$store.getters.isSupplier) {
        params.companyCd = this.$store.getters.companyCd
      }
      const elements = await API.get('/master/companies', params)
      elements.forEach((element) => {
        element['companyText'] = element['companyCd'] + ': ' + element['companyName']
        this.items.push(element)
      })

      if (this.$store.getters.isSupplier) {
        this.model = this.$store.getters.companyCd
      }
    } catch (error) {
      this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0002') })))
    } finally {
      this.loading = false
    }
  },
}
</script>
